import { Button, Text, XStack, YStack } from '@/components/ui';
import { PaperSkeleton } from '@/features/artifacts/ArtifactPaper';
import { cn } from '@/lib/utils';

interface MeetingOptInBannerProps {
  title: string;
  subtitle: string;
  onTurnOn: () => void;
  onDismiss: () => void;
  turnOnAriaLabel?: string;
  dismissAriaLabel?: string;
}

export const MeetingOptInBanner = ({
  title,
  subtitle,
  onTurnOn,
  onDismiss,
  turnOnAriaLabel,
  dismissAriaLabel,
}: MeetingOptInBannerProps) => (
  <XStack
    className={cn(
      'relative items-center gap-4 rounded-2xl p-4 md:pl-40',
      'border border-border',
      'bg-gradient-to-r from-brand-jordy-blueA/5 to-transparent'
    )}
  >
    <div
      aria-hidden
      inert
      className="pointer-events-none absolute -top-12 bottom-0 left-0 hidden w-36 overflow-hidden rounded-bl-2xl md:block"
    >
      <div className="absolute left-1/2 top-[2.375rem] h-[9.375rem] w-[7.5rem] -translate-x-1/2 -rotate-[5deg] overflow-hidden rounded-md border border-grayA-3 bg-surface shadow-md">
        <PaperSkeleton variant="text" />
      </div>
    </div>
    <YStack className="relative min-w-0 flex-1 gap-0.5">
      <Text className="font-semibold">{title}</Text>
      <Text size="sm" variant="subtle" className="text-balance">
        {subtitle}
      </Text>
    </YStack>
    <XStack className="relative shrink-0 items-center gap-1">
      <Button
        variant="ghost"
        size="sm"
        aria-label={dismissAriaLabel}
        onClick={onDismiss}
      >
        Not now
      </Button>
      <Button
        variant="default"
        size="sm"
        aria-label={turnOnAriaLabel}
        onClick={onTurnOn}
      >
        Turn on
      </Button>
    </XStack>
  </XStack>
);
